import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import MySnippets from "./pages/MySnippets";
import AddSnippet from "./pages/AddSnippet";
import EditSnippet from "./pages/EditSnippet";

const App = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <Router>
      <Routes>
        <Route
          path="/home"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Home />}
        />
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />}
        />
        <Route
          path="/register"
          element={
            isAuthenticated ? <Navigate to="/dashboard" /> : <Register />
          }
        />
        <Route
          path="/dashboard"
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/home" />}
        />
        <Route
          path="/my-snippets"
          element={isAuthenticated ? <MySnippets /> : <Navigate to="/home" />}
        />
        <Route
          path="/add-snippet"
          element={isAuthenticated ? <AddSnippet /> : <Navigate to="/home" />}
        />
        <Route
          path="/edit-snippet/:id"
          element={isAuthenticated ? <EditSnippet /> : <Navigate to="/home" />}
        />
        <Route
          path="*"
          element={<Navigate to={isAuthenticated ? "/dashboard" : "/home"} />}
        />
      </Routes>
    </Router>
  );
};

export default App;
